import jwtDecode from 'jwt-decode';

function accessToken() {
  const accessToken = localStorage.getItem('accessToken');
  return accessToken;
}

function refreshToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  return refreshToken;
}

export function getAccessToken() {
  return accessToken();
}

export function getRefreshToken() {
  return refreshToken();
}

export function getDecodedAccessToken() {
  return jwtDecode(accessToken());
}

export function getDecodedRefreshToken() {
  return jwtDecode(refreshToken());
}

export function getAccessTokenExp() {
  return getDecodedAccessToken().exp;
}

export function getRefreshTokenExp() {
  return getDecodedRefreshToken().exp;
}

export function createAccessToken(res) {
  localStorage.setItem('accessToken', res);
}

export function createRefreshToken(res) {
  localStorage.setItem('refreshToken', res);
}

export function removeAccessToken() {
  localStorage.removeItem('accessToken');
}

export function removeRefreshToken() {
  localStorage.removeItem('refreshToken');
}

export function removeTokens() {
  localStorage.removeItem('accessToken');
  // localStorage.removeItem('refreshToken');
  
}